export enum WeitereToebStatus {
  Abgewaehlt = 'abgewaehlt',
  NichtZustaendig = 'nicht_zustaendig',
  NichtZustaendigAberImUmkreisVon2Km = 'nicht_zustaendig_2k',
  NichtErreichbar = 'nicht_erreichbar'
}
